import JoinTheCommunity from "./JoinTheCommunity";

export default JoinTheCommunity;
